import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "w-full" };
import { useFieldError, useSetFieldError } from 'vee-validate';
import EErrorMessage from '@common/ui/EError/components/EErrorMessage.vue';
import { ZodType } from 'zod';
import { computed, ref, toRef, watch } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'EError',
    props: {
        name: {},
        hideError: { type: Boolean },
        position: { default: 'left' },
        rule: {},
        value: {}
    },
    emits: ["changeErrorStatus"],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var name = toRef(props, 'name');
        var canValidateRule = ref(false);
        var fieldError = useFieldError(name);
        var setFieldError = useSetFieldError(name);
        var isZodOptions = function (rule) {
            return !(props.rule instanceof ZodType);
        };
        var validateOnMount = computed(function () {
            if (props.rule && isZodOptions(props.rule)) {
                return !!props.rule.validateOnMount;
            }
            return false;
        });
        var ruleError = computed(function () {
            var _a;
            try {
                if (props.rule && !isZodOptions(props.rule)) {
                    (_a = props.rule) === null || _a === void 0 ? void 0 : _a.parse(props.value);
                }
                return '';
            }
            catch (zodError) {
                return zodError.errors[0].message;
            }
        });
        var message = computed(function () { return ruleError.value || fieldError.value || ''; });
        var showErrorMessage = computed(function () { return !props.hideError && ((props.rule && canValidateRule.value) || props.name); });
        // если это field, то валидация при маунте будет на его стороне
        watch(message, function (v) {
            if (!props.name)
                return;
            emit('changeErrorStatus', !!v);
        }, { immediate: true });
        // если это rule, то валидация при маунте наша
        watch(message, function (v) {
            if (!props.rule)
                return;
            canValidateRule.value = true;
            // ! может помочь, если есть rules и name: у компонента EInputPhone так, он внутри себя чекает номер, и после ошибки ее надо прокидывать наверх уже в сам useForm
            // ! но пока в комменте, если ты здесь, то попробуй раскомментить
            // setFieldError(v)
            emit('changeErrorStatus', !!v);
        }, { immediate: validateOnMount.value });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _renderSlot(_ctx.$slots, "default"),
                (showErrorMessage.value)
                    ? (_openBlock(), _createBlock(EErrorMessage, {
                        key: 0,
                        message: message.value,
                        position: _ctx.position
                    }, null, 8, ["message", "position"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
